import React, { useState } from 'react';
import { Form, Radio, Spin } from 'components/ds';
import PageContainer from 'modules/account/components/PageContainer/PageContainer';
import { useNavigate } from 'react-router-dom';
import ProgressStepper from 'components/ProgressStepper';
import { useGetTemplate } from 'modules/account/configs/SchemaConfig';
import routes from 'modules/account/configs/RoutesConfig';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { usePostSignupOtp } from '../../../services/ValidationService';
import { ButtonLarge, DescriptionContainer, FooterDiv } from 'components/Css';
import { RadioGroupStyled } from '../styles';
import { ValidatorField } from 'components/ValidatorField';

const SignupValidation: React.FC = () => {
  const [form] = Form.useForm() as any;

  const [value, setValue] = useState('sms');

  const navigate = useNavigate();

  const contact = ApiLocalStorage.get('contact');
  const register = ApiLocalStorage.get('register');
  const { isLoading: isLoadingTemplate, data: pageConfig = {} } = useGetTemplate('signupValidation');
  const { mutateAsync: requestOtp, isLoading: isLoadingOtp } = usePostSignupOtp();

  const handleNext = async (values: any) => {
    try {
      const validationType = values.validationOption;
      const contactValue = validationType === 'email' ? contact?.email : contact?.phoneNumber;

        await requestOtp({
          participantId: register.participantId,
          type: validationType.toUpperCase(),
          email: validationType === 'email' ? contactValue : undefined,
          phoneNumber: validationType === 'sms' ? ValidatorField.extractNumbers(contactValue) : undefined
        })
        navigate(routes.signupValidationCode.path)
    
    } catch (error) {
      console.error('Erro ao solicitar código:', error);
    }
  };

  const onChange = (e: any) => {
    setValue(e.target.value);
  };

  const submitForm = () => {
    form.submit();
  };

  if (isLoadingTemplate || isLoadingOtp) {
    return (
      <PageContainer>
        <Spin style={{ marginBottom: '65px' }} size="large" />
      </PageContainer>
    );
  }

  return (
    <PageContainer title={pageConfig.title} navigateBack={pageConfig?.navigateBack?.()}>
      <ProgressStepper totalSteps={pageConfig.totalSteps} currentStep={pageConfig.currentStep} />
      <DescriptionContainer>{pageConfig.description}</DescriptionContainer>
      <Form form={form} layout='vertical' onFinish={handleNext}>
        <Form.Item
          name='validationOption'
          initialValue='sms'
          rules={[{ required: true, message: 'Por favor, selecione uma opção!' }]}
        >
          <RadioGroupStyled onChange={onChange} value={value}>
            <Radio value='email'>{contact?.email}</Radio>
            <Radio value='sms'>{contact?.phoneNumber}</Radio>
          </RadioGroupStyled>
        </Form.Item>
      </Form>
      <FooterDiv>
        <ButtonLarge onClick={submitForm}>
          {pageConfig.labelNext || 'Próximo'}
        </ButtonLarge>
      </FooterDiv>
    </PageContainer>
  );
};

export default SignupValidation;
